<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">{{ showForm ? (isEdit ? 'EDITAR CLIENTE' : 'AGREGAR CLIENTE') : 'ADMINISTRAR CLIENTES' }}</h1>
    </section>

    <!-- List View -->
    <mat-card class="mat-elevation-z0" *ngIf="!showForm">
      <div>
        <button mat-raised-button class="add-btn" (click)="addClient()">Agregar Nuevo</button>
      </div>
      <table mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="dsRazonSocial">
          <th mat-header-cell *matHeaderCellDef class="table-header"> Razon Social</th>
          <td mat-cell *matCellDef="let client" class="table-content"> {{client.dsRazonSocial}} </td>
        </ng-container>

        <ng-container matColumnDef="dsCUIT">
          <th mat-header-cell *matHeaderCellDef class="table-header"> CUIT </th>
          <td mat-cell *matCellDef="let client" class="table-content"> {{client.dsCUIT}} </td>
        </ng-container>

        <ng-container matColumnDef="dsNombreFantasia">
          <th mat-header-cell *matHeaderCellDef class="table-header"> Nombre Fantasia </th>
          <td mat-cell *matCellDef="let client" class="table-content"> {{client.dsNombreFantasia}} </td>
        </ng-container>

        <ng-container matColumnDef="dsEmail">
          <th mat-header-cell *matHeaderCellDef class="table-header"> Email </th>
          <td mat-cell *matCellDef="let client" class="table-content"> {{client.dsEmail}} </td>
        </ng-container>

        <ng-container matColumnDef="dsTelefono">
          <th mat-header-cell *matHeaderCellDef class="table-header"> Telefono </th>
          <td mat-cell *matCellDef="let client" class="table-content"> {{client.dsTelefono}} </td>
        </ng-container>

        <ng-container matColumnDef="isEstado">
          <th mat-header-cell *matHeaderCellDef class="table-header"> Estado </th>
          <td mat-cell *matCellDef="let client" class="table-content"
            [style.color]="client.isEstado ? '#2C57A7' : '#F44336'">
            {{client.isEstado ? 'Activo' : 'Inactivo'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="opcion">
          <th mat-header-cell *matHeaderCellDef class="table-header"> Opcion </th>
          <td mat-cell *matCellDef="let client" class="table-content">
            <button mat-mini-fab class="edit-btn"
              matTooltip="Editar cliente" (click)="editClient(client.cdClient)">
              <mat-icon>create</mat-icon>
            </button>
            <button mat-mini-fab class="delete-btn"
              matTooltip="Eliminar cliente" (click)="deleteClient(client)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <mat-paginator
        [length]="totalCount"
        [pageIndex]="pageNumber - 1"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPageChange($event)">
      </mat-paginator>
    </mat-card>

    <!-- Form View -->
    <section *ngIf="showForm">
      <form [formGroup]="clientForm" (ngSubmit)="saveClient()">
        <mat-card>
          <div fxLayout="row wrap" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>Razon Social</mat-label>
                <input matInput formControlName="dsRazonSocial" required>
                <mat-error *ngIf="clientForm.controls['dsRazonSocial'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>CUIT</mat-label>
                <input matInput formControlName="dsCUIT" appNumericOnly type="text" inputmode="numeric" required maxlength="11">
                <mat-error *ngIf="clientForm.controls['dsCUIT'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>Nombre Fantasia</mat-label>
                <input matInput formControlName="dsNombreFantasia" required>
                <mat-error *ngIf="clientForm.controls['dsNombreFantasia'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput formControlName="dsEmail" required>
                <mat-error *ngIf="clientForm.controls['dsEmail'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
                <mat-error *ngIf="clientForm.controls['dsEmail'].hasError('email')">
                  Ingrese un email valido
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>Telefono</mat-label>
                <input matInput formControlName="dsTelefono" appNumericOnly type="text" inputmode="numeric" maxlength="10">
              </mat-form-field>
            </div>
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>Direccion</mat-label>
                <input matInput formControlName="dsDireccion" required>
                <mat-error *ngIf="clientForm.controls['dsDireccion'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>Localidad</mat-label>
                <input matInput formControlName="cdLocalidad">
              </mat-form-field>
            </div>
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>Contacto</mat-label>
                <input matInput formControlName="dsContacto">
              </mat-form-field>
            </div>
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>Observaciones</mat-label>
                <textarea matInput formControlName="dsObservaciones" rows="3"></textarea>
              </mat-form-field>
            </div>
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>Servicios</mat-label>
                <mat-select formControlName="cdServices" multiple required>
                  <mat-option *ngFor="let service of services" [value]="service.cdService">
                    {{service.dsNombre}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="clientForm.controls['cdServices'].hasError('required')">
                  Debe seleccionar al menos un servicio
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="45">
              <mat-form-field appearance="outline">
                <mat-label>Estado</mat-label>
                <mat-select formControlName="isEstado" required>
                  <mat-option *ngFor="let option of statusOptions" [value]="option.value">
                    {{option.viewValue}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="clientForm.controls['isEstado'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
        <br>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1rem">
          <button mat-flat-button type="submit" [disabled]="!clientForm.valid || saving" class="save-changes">
            GUARDAR CAMBIOS
          </button>
          <button mat-raised-button type="button" class="cancel-changes" (click)="cancelForm()">
            CANCELAR
          </button>
        </div>
      </form>
    </section>

  </div>
</div>
